<div class="mb-grid-container-full header-mobile">
  <div class="mb-grid-col-12 header-mobile__hotel-info-wrapper">
    <div *ngIf="isDisney" class="header-mobile__hotel-info-wrapper__disney-badge">
      <mb-badge color="dark" size="small">
        <mb-icon icon="disney"></mb-icon>
        <span>Hotel Disney</span>
      </mb-badge>
    </div>
    <div class="header-mobile__carousel">
      <mb-carousel
        backgroundImage
        class="carousel"
        [infinity]="false"
        [showNumbers]="true"
        [showDots]="true"
        [images]="images$ | async"
      ></mb-carousel>
    </div>
    <div class="header-mobile__hotel-info">
      <h1 class="name">{{ hotelName }}</h1>
      <ng-container *ngIf="dataLoaded$ | async">
        <div
          *ngIf="isHotel; else homestay"
          class="header-mobile__hotel-info__hotel-stars"
        >
          <mb-stars-rating [rating]="stars"></mb-stars-rating>
        </div>
        <ng-template #homestay>
          <div class="header-mobile__hotel-info--homestay">
            <span> Alquiler temporario </span>
            <ng-container *ngIf="beds > 0 && maxRoomOccupancy > 0">
              <div class="homestay-data">
                <span class="separator"></span>
                <mb-icon-text class="occupancy">
                  <mb-icon icon="adult"></mb-icon>
                  <span>{{ maxRoomOccupancy }} </span>
                </mb-icon-text>
                <mb-icon-text>
                  <mb-icon icon="hotels"></mb-icon>
                  <span>{{ beds }} camas</span>
                </mb-icon-text>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
